/**
 * Rodapé do modal de contato — C-75 (ajuste de 14/10).
 * Esquerda: "Desativar" (ativo) ou "Ativar" (inativo), só na edição; quando a
 * desativação está travada, o botão fica desabilitado e a explicação aparece.
 * Direita: "Cancelar" e o envio ("Salvar alterações" / "Cadastrar contato").
 */
import type { ContatoGestao } from '@/services/datasources';

const BOTAO = 'rounded-md px-3 py-1.5 text-xs font-bold disabled:cursor-not-allowed disabled:opacity-50';

interface Props {
  /** `null` = criação (sem Desativar/Ativar). */
  contato: ContatoGestao | null;
  /** Motivo da trava de desativação, ou `null`. */
  bloqueio: string | null;
  ocupado: boolean;
  /** Algo mudou em relação ao gravado (habilita "Salvar alterações"). */
  mudou: boolean;
  /** Edição não salva: Ativar/Desativar fecham o modal e a perderiam. */
  pendente: boolean;
  salvando: boolean;
  onDesativar: () => void;
  onAtivar: () => void;
  onCancelar: () => void;
}

export default function RodapeContato(props: Props) {
  const { contato, ocupado, mudou, pendente, salvando, onDesativar, onAtivar, onCancelar } = props;
  const bloqueio = props.bloqueio ?? (pendente ? 'Salve ou cancele as alterações antes de ativar ou desativar.' : null);
  return (
    <div className="mt-4 flex items-start justify-between gap-3">
      <div className="min-w-0 flex-1">
        {contato?.is_active && (
          <>
            <button
              type="button"
              disabled={ocupado || bloqueio !== null}
              aria-describedby={bloqueio ? 'contato-bloqueio' : undefined}
              onClick={onDesativar}
              className={`${BOTAO} border border-red-500/50 text-red-300 hover:bg-red-500/10`}
            >
              Desativar
            </button>
            {bloqueio && <p id="contato-bloqueio" className="mt-1 text-[10px] text-jf-dim">{bloqueio}</p>}
          </>
        )}
        {contato && !contato.is_active && (
          <>
            <button
              type="button"
              disabled={ocupado || pendente}
              aria-describedby={bloqueio ? 'contato-bloqueio' : undefined}
              onClick={onAtivar}
              className={`${BOTAO} border border-jf-border text-white`}
            >
              Ativar
            </button>
            {bloqueio && <p id="contato-bloqueio" className="mt-1 text-[10px] text-jf-dim">{bloqueio}</p>}
          </>
        )}
      </div>
      <div className="flex shrink-0 gap-2">
        <button type="button" onClick={onCancelar} disabled={ocupado} className={`${BOTAO} border border-jf-border text-jf-muted hover:text-white`}>
          Cancelar
        </button>
        <button type="submit" disabled={ocupado || !mudou} className={`${BOTAO} bg-jf-yellow text-jf-bg`}>
          {salvando ? 'Salvando…' : contato ? 'Salvar alterações' : 'Cadastrar contato'}
        </button>
      </div>
    </div>
  );
}
